export default "__VITE_ASSET__9ea0c250__"